<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>
<script>
// 引入基本模板
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "300px",
    },
  },
  data() {
    return {
      chart: null,
      date: [],
      option: {
        legend: {
          icon: "rect",
          data: ['新总分序', '四科序',]
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '8%',
          left: '4%',
          right: '2%',
          bottom: '5%',
          containLable: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#666',//左边线的颜色
            }
          },
          // axisLine: {onZero: false}
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#666',//左边线的颜色
            }
          },
          // inverse: true
        },
        series: [
          {
            // data: [820, 932, 901, 934, 1290],
            data: [],
            type: "line",
            symbolSize: 8,
            smooth: false,
            name: '新总分序',
            itemStyle: {
              normal: {
                color: "orange",
                lineStyle: {
                  color: "orange"
                }
              }
            },
            label: {
              show: true,
            },
          },
          {
            data: [],
            symbolSize: 8,
            type: "line",
            name: '四科序',
            smooth: false,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            },
            label: {
              show: true,
            },
          },
        ],
      },
    };
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data) {
      console.log(data)
      this.option.series[0].data = [];
      this.option.series[1].data = [];
      this.option.xAxis.data = [];
      for (var i = 0; i < data.length; i++) {
        console.log(data[i].ExamCode)
        if(data[i].ExamCode == "数次平均") {
          continue;
        }
        this.option.series[0].data.push(data[i].NewTotalSn>0?data[i].NewTotalSn:0);
        this.option.series[1].data.push(data[i].FourSn>0?data[i].FourSn:0);
        this.option.xAxis.data.push(data[i].ExamCode)
      }
      this.chart = echarts.init(this.$el, "macarons");
      this.chart.setOption(this.option);
    },
  },
};
</script>
<style lang="scss">
.chart {
  @media screen and (max-width: 767px) {
    margin-top: -30px;
  }
}
</style>